import React, { useState } from 'react';
// API base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL || 'https://api.veridicus.com.br'
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';
  
const EmailView = ({ email, onReply, onForward, onDelete }) => {
  const [showDetails, setShowDetails] = useState(false);

  const formatDate = (date) => {
    return new Date(date).toLocaleString('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const downloadAttachment = async (attachment) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${API_BASE_URL}/api/emails/attachment/${attachment.id}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = attachment.filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error('Error downloading attachment:', error);
    }
  };

  return (
    <div className="email-view">
      <div className="email-view-header">
        <h2 className="email-subject">{email.subject || '(sem assunto)'}</h2>
        
        <div className="email-actions">
          <button className="action-btn" onClick={() => window.print()} title="Imprimir">
            <i className="fas fa-print"></i>
          </button>
          <button className="action-btn" onClick={onDelete} title="Excluir">
            <i className="fas fa-trash"></i>
          </button>
        </div>
      </div>
      
      <div className="email-meta">
        <div className="sender-info">
          <div className="sender-avatar">
            {email.from?.charAt(0).toUpperCase()}
          </div>
          
          <div className="sender-details">
            <div className="sender-name">
              <strong>{email.fromName || email.from}</strong>
              <span className="sender-email">&lt;{email.from}&gt;</span>
            </div>
            
            <div className="recipient-info">
              <span>para {email.to}</span>
              {email.cc && <span>, cc: {email.cc}</span>}
            </div>
          </div>
          
          <div className="email-timestamp">
            {formatDate(email.date)}
            <button 
              className="details-toggle"
              onClick={() => setShowDetails(!showDetails)}
            >
              <i className={`fas fa-chevron-${showDetails ? 'up' : 'down'}`}></i>
            </button>
          </div>
        </div>
        
        {showDetails && (
          <div className="email-details">
            <div className="detail-row">
              <span className="detail-label">De:</span>
              <span className="detail-value">{email.from}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Para:</span>
              <span className="detail-value">{email.to}</span>
            </div>
            {email.cc && (
              <div className="detail-row">
                <span className="detail-label">Cc:</span>
                <span className="detail-value">{email.cc}</span>
              </div>
            )}
            {email.bcc && (
              <div className="detail-row">
                <span className="detail-label">Cco:</span>
                <span className="detail-value">{email.bcc}</span>
              </div>
            )}
            <div className="detail-row">
              <span className="detail-label">Data:</span>
              <span className="detail-value">{formatDate(email.date)}</span>
            </div>
          </div>
        )}
      </div>
      
      <div className="email-body" dangerouslySetInnerHTML={{ __html: email.body }} />
      
      {email.attachments && email.attachments.length > 0 && (
        <div className="email-attachments">
          <h4>Anexos ({email.attachments.length})</h4>
          <div className="attachment-list">
            {email.attachments.map((attachment, index) => (
              <div key={index} className="attachment-item">
                <i className="fas fa-paperclip"></i>
                <span className="attachment-name">{attachment.filename}</span>
                <span className="attachment-size">({attachment.size})</span>
                <button 
                  className="download-btn"
                  onClick={() => downloadAttachment(attachment)}
                >
                  <i className="fas fa-download"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="email-actions-footer">
        <button className="email-btn reply-btn" onClick={onReply}>
          <i className="fas fa-reply"></i>
          Responder
        </button>
        <button className="email-btn reply-all-btn" onClick={onReply}>
          <i className="fas fa-reply-all"></i>
          Responder a todos
        </button>
        <button className="email-btn forward-btn" onClick={onForward}>
          <i className="fas fa-share"></i>
          Encaminhar
        </button>
      </div>
    </div>
  );
};

export default EmailView;